import type { BoggleResolvedChallengeBonus } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBonusDisplayFromDefinition } from '~/boggle/config/bonuses/formatResolvedBonusDisplay'
import type { BoggleChallengeBonusResolverContext } from '~/boggle/lib/challenge/resolveModFamily'
import type { BoggleBonusValue } from '../types'
import type { BoggleChallengeBonusDefinition } from '../bonusDefinition'

export const longshotBonusDefinition: BoggleChallengeBonusDefinition = {
  description: 'Word is at least 6 letters long',
  id: 'longshot',
  name: 'Longshot',
  parameterDefinitions: {},
  selectionWeight: 1,
  shortLabel: '6+ letters',
}

export const shotgunBonusDefinition: BoggleChallengeBonusDefinition = {
  description: 'Word is 4 letters or fewer',
  id: 'shotgun',
  name: 'Shotgun',
  parameterDefinitions: {},
  selectionWeight: 1,
  shortLabel: '≤4 letters',
}

export function resolveWordLengthBonus(
  family: BoggleChallengeBonusDefinition,
  rngState: number,
  _context: BoggleChallengeBonusResolverContext,
  value: BoggleBonusValue,
): {
  mod: BoggleResolvedChallengeBonus
  rngState: number
} {
  const display = formatResolvedBonusDisplayFromDefinition(family, {})

  return {
    mod: {
      description: display.description,
      effects: [],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [],
      parameters: {},
      shortLabel: display.shortLabel,
      value,
    },
    rngState,
  }
}
